import { createAction } from '@reduxjs/toolkit';

import { TrackingDeviceAssignment } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import {
  CreateTrackingDeviceAssignmentRequest,
  RetrieveTrackingDeviceAssignmentsRequest
} from './device-assignment.types';

export const requestCreateTrackingDeviceAssignment = createAction<
  SagaPayload<CreateTrackingDeviceAssignmentRequest, TrackingDeviceAssignment>['payload']
>('device-assignment/createTrackingDeviceAssignment');

export const requestRetrieveTrackingDeviceAssignments = createAction<
  SagaPayload<RetrieveTrackingDeviceAssignmentsRequest, TrackingDeviceAssignment[]>['payload']
>('device-assignment/retrieveTrackingDeviceAssignments');
